import { Component, Input, TemplateRef } from "@angular/core";

@Component({
  selector: "app-e-invoice-pdf-viewer",
  templateUrl: "./e-invoice-pdf-viewer.component.html",
  standalone: false,
})
export class EInvoicePdfViewerComponent {
  @Input() fileUrl!: string;
  @Input() id!: string;
  @Input() modalPdf!: TemplateRef<unknown>;
}
